import { mergeDeep } from 'remeda';
import type { DynamicCoreQuestionState, StoreState } from '../../state-types';
import { getCoreQuestionActiveShortIdList } from '../core-questions/get-core-question-active-list-by-short-id';
import { makeSurveyDirty } from '../utils/make-survey-dirty';
import { setPath } from '../utils/set-path';

/** Update a Dynamic Core Question card `maximizeResponses` and conditionally includes all core questions when the value is true */
export const updateCardMaximizeResponses =
    (
        cardId: string,
        maximizeResponses: DynamicCoreQuestionState['maximizeResponses']
    ) =>
    (state: StoreState): StoreState => {
        const prevCard = state.cards[cardId];

        // includes all active core questions if maximizeResponses is true
        const updatedQuestionIds = maximizeResponses
            ? {
                  questionIds: getCoreQuestionActiveShortIdList(state),
              }
            : {};

        const newCard = {
            ...prevCard,
            // set maximizeResponses value
            maximizeResponses,
            // set questionIds to all active core questions if maximizeResponses is true
            ...updatedQuestionIds,
        };

        const newState = setPath(
            state,
            ['cards', cardId],
            mergeDeep(prevCard, newCard)
        );

        return makeSurveyDirty(newState);
    };
